// LIBRARIES //
import React from 'react';
import { Avatar } from 'antd';
import styled from 'styled-components';
import { Divider, AntdButton, colors } from '@yuhuinc/ui-library';

// COMPONENTS //
import CardHeader from '../CardComponent/CardHeader';
import CardBody from '../CardComponent/CardBody';
import AutoPayStatus from './AutoPayStatus';

// HELPERS //
import { getTranslatedString } from 'helpers/i18n';
import { formatPhone } from 'helpers/Formatter';
import { buttonColors, primaryButtonColors } from '../ButtonColors';

const AVATAR_SIZE = 178;

const AlignLeft = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const ResidentContact = styled.div`
  padding: 25px 24px;
  display: inline-block;
`;

const ResidentInfo = styled.div`
  font-size: 16px;
`;

const ButtonSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`;

const StyledP = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
`;

const StyledPBolded = styled(StyledP)`
  font-weight: 600;
`;

const StyledHeading = styled.p`
  line-height: 24px;
  font-size: 18px
`;

const StyledText = styled.p`
  line-height: 20px;
  font-size: 16px
`;

const listVehicles = (vehicles) => {
  if (!Array.isArray(vehicles)) return [];

  const mappedVehicles = vehicles.map((vehicle) => `${vehicle.make}, ${vehicle.plate_number}`);

  return mappedVehicles.join('\n');
}

const listPets = (pets) => {
  if (!Array.isArray(pets)) return [];

  const mappedPets = pets.map((pet) => {
    let petString = `${pet.breed}, ${pet.name}`;

    if (pet.service_animal) {
      petString += ` (${'Service Animal'})`;
    }

    return petString;
  })

  return mappedPets.join('\n');
}

const listOccupants = (occupants) => {
  if (!Array.isArray(occupants)) return [];

  const mappedOccupants = occupants.map((occupant) => `${occupant.full_name}, ${occupant.relationship}`);

  return mappedOccupants.join('\n');
}

const ResidentDetails = ({ residentData, disabledProfilePicture, toggleChatDrawer }) => {
  if (!residentData) return (<></>); // will be removed once a loading state is added

  const vehiclesList = listVehicles(residentData.vehicle_information);
  const petsList = listPets(residentData.pets);
  const occupantsList = listOccupants(residentData.other_occupants);

  return (
    <div>
      <CardHeader>{getTranslatedString('residentDrawer.residentDetailTab.residentDetails.title')}</CardHeader>
      <CardBody>
        <AlignLeft>
          {!disabledProfilePicture && (
            <Avatar shape="square" size={AVATAR_SIZE} icon='user' style={{ backgroundColor: colors.colors.gray[1], color: colors.colors.gray[3] }} />
          )}
          <ResidentContact>
            <AutoPayStatus residentData={residentData} />
            <StyledPBolded>{residentData.full_name}</StyledPBolded>
            <StyledP>{residentData.email}</StyledP>
            <StyledP>{formatPhone(residentData.phone_number)}</StyledP>
          </ResidentContact>
        </AlignLeft>
        <Divider />
        <ResidentInfo>
          {vehiclesList.length > 0 && <StyledHeading>{getTranslatedString('residentDrawer.residentDetailTab.residentDetails.vehicle')}</StyledHeading>}
          <StyledText>{vehiclesList}</StyledText>

          {petsList.length > 0 && <StyledHeading>{getTranslatedString('residentDrawer.residentDetailTab.residentDetails.pets')}</StyledHeading>}
          <StyledText>{petsList}</StyledText>

          {occupantsList.length > 0 && <StyledHeading>{getTranslatedString('residentDrawer.residentDetailTab.residentDetails.occupants')}</StyledHeading> }
          <StyledText>{occupantsList}</StyledText>

          <ButtonSection>
            <AntdButton
              type='primary'
              label={getTranslatedString('residentDrawer.residentDetailTab.residentDetails.chatButton')}
              style={primaryButtonColors}
              onClick={toggleChatDrawer}
            />
            <AntdButton
              label={getTranslatedString('residentDrawer.residentDetailTab.residentDetails.editResidentButton')}
              style={buttonColors}
            />
          </ButtonSection>
        </ResidentInfo>
      </CardBody>
    </div>
  )
}

export default ResidentDetails;
